export default {
  BASE_API: 'https://splinter.cloud.yuze.uk'
}
